import WsProvider from './provider/WSProvider';

var serviceName = 'webservis';
var moduleName = 'silinenLog';

var logService = {
    veriPath: WsProvider.veriPath,
    variablePath: WsProvider.variablePath,
    silinenLoglar(islem, baslangic, limit) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[islem]': islem,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            serviceName: moduleName,
            methodName: 'listele',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
};
export default logService;
